module.exports = __webpack_public_path__ + "files/8060ee00a7244802688aa18e53bddfa5.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/places-1.png
// module id = 1469
// module chunks = 60